var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unlock-login" },
    [
      !_vm.isPhone
        ? _c("div", { staticClass: "login-container" }, [
            _c("div", { staticClass: "login-form-container" }, [
              _c(
                "div",
                { staticStyle: { width: "68%" } },
                [
                  _c(
                    "div",
                    { staticClass: "text-login color-main-linear-blue" },
                    [_vm._v(" LOGIN ")]
                  ),
                  _c(
                    "el-form",
                    {
                      ref: "loginForm",
                      staticClass: "login-form",
                      attrs: {
                        model: _vm.loginForm,
                        rules: _vm.loginRules,
                        "auto-complete": "on",
                        "label-position": "top",
                      },
                    },
                    [
                      _c("div", { staticClass: "title-container" }, [
                        _c("h3", { staticClass: "title" }, [
                          _vm._v("Sign In to your account"),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "login-form-item",
                          attrs: { prop: "email", label: "Email" },
                        },
                        [
                          _c("el-input", {
                            ref: "email",
                            staticClass: "login-input",
                            attrs: {
                              placeholder: "Email",
                              name: "email",
                              type: "text",
                              tabindex: "1",
                              "auto-complete": "on",
                              size: "default",
                            },
                            model: {
                              value: _vm.loginForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.loginForm, "email", $$v)
                              },
                              expression: "loginForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "login-form-item",
                          attrs: { prop: "password", label: "Password" },
                        },
                        [
                          _c("el-input", {
                            key: _vm.passwordType,
                            ref: "password",
                            staticClass: "login-input",
                            attrs: {
                              type: _vm.passwordType,
                              placeholder: "Password",
                              name: "password",
                              tabindex: "2",
                              "auto-complete": "on",
                              size: "default",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleLogin($event)
                              },
                            },
                            model: {
                              value: _vm.loginForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.loginForm, "password", $$v)
                              },
                              expression: "loginForm.password",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "show-pwd",
                              on: { click: _vm.showPwd },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.passwordType === "password"
                                      ? "eye"
                                      : "eye-open",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.show_mfa_flag
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "verify_code" } },
                            [
                              _c("el-input", {
                                ref: "verify_code",
                                staticClass: "login-input",
                                staticStyle: { margin: "10px 0" },
                                attrs: {
                                  placeholder: "MFA Verification Code",
                                  oninput: "value=value.replace(/[^\\d]/g,'')",
                                },
                                model: {
                                  value: _vm.loginForm.verify_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "verify_code", $$v)
                                  },
                                  expression: "loginForm.verify_code",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-form-item", [
                        _c(
                          "div",
                          {
                            staticClass: "forgot-password",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("/forgotPassword")
                              },
                            },
                          },
                          [_vm._v("Forgot your password?")]
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "bg-color-main-linear-blue",
                          staticStyle: {
                            width: "100%",
                            "margin-bottom": "30px",
                            "font-weight": "600",
                          },
                          attrs: {
                            loading: _vm.loading,
                            type: "info",
                            size: "default",
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleLogin($event)
                            },
                          },
                        },
                        [_vm._v("Login")]
                      ),
                    ],
                    1
                  ),
                  _c("div", [
                    _c("img", {
                      staticClass: "login-bottom-logo",
                      attrs: {
                        src: _vm.$store.getters.isAruxpay
                          ? require("@/assets/logo/aruxpay_logo.png")
                          : require("@/assets/logo/ezpay_logo.svg"),
                      },
                    }),
                    _c("div", { staticClass: "text-all-right" }, [
                      _vm._v(
                        "©️ " +
                          _vm._s(new Date().getFullYear()) +
                          " " +
                          _vm._s(
                            _vm.$store.getters.isAruxpay ? "Aruxpay" : "Ezpay"
                          ) +
                          " Information Solutions Corp, All Rights Reserved"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "login-img" }, [
              _c("img", {
                attrs: {
                  width: "100%",
                  src: _vm.$store.getters.isAruxpay
                    ? require("@/assets/logo/aruxpay_logo_big.svg")
                    : require("@/assets/logo/logo_big.svg"),
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm.isPhone
        ? _c("div", { staticClass: "xs-login-container" }, [
            _c("div", { staticClass: "xs-login-container-content" }, [
              _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "text-login color-main-linear-blue" },
                    [_vm._v(" LOGIN ")]
                  ),
                  _c("div", [
                    _c("img", {
                      staticClass: "login-img",
                      attrs: {
                        width: "60%",
                        src: _vm.$store.getters.isAruxpay
                          ? require("@/assets/logo/aruxpay_logo_big.svg")
                          : require("@/assets/logo/logo_big.svg"),
                      },
                    }),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "loginForm",
                      staticClass: "xs-login-form",
                      attrs: {
                        model: _vm.loginForm,
                        rules: _vm.loginRules,
                        "auto-complete": "on",
                        "label-position": "top",
                      },
                    },
                    [
                      _c("div", { staticClass: "title-container" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Sign In to your account"),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "login-form-item",
                          attrs: { prop: "email", label: "Email" },
                        },
                        [
                          _c("el-input", {
                            ref: "email",
                            staticClass: "login-input",
                            attrs: {
                              placeholder: "Email",
                              name: "email",
                              type: "text",
                              tabindex: "1",
                              "auto-complete": "on",
                              size: "default",
                            },
                            model: {
                              value: _vm.loginForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.loginForm, "email", $$v)
                              },
                              expression: "loginForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "login-form-item",
                          attrs: { prop: "password", label: "Password" },
                        },
                        [
                          _c("el-input", {
                            key: _vm.passwordType,
                            ref: "password",
                            staticClass: "login-input",
                            attrs: {
                              type: _vm.passwordType,
                              placeholder: "Password",
                              name: "password",
                              tabindex: "2",
                              "auto-complete": "on",
                              size: "default",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleLogin($event)
                              },
                            },
                            model: {
                              value: _vm.loginForm.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.loginForm, "password", $$v)
                              },
                              expression: "loginForm.password",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "show-pwd",
                              on: { click: _vm.showPwd },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.passwordType === "password"
                                      ? "eye"
                                      : "eye-open",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.show_mfa_flag
                        ? _c(
                            "el-form-item",
                            { attrs: { prop: "verify_code" } },
                            [
                              _c("el-input", {
                                ref: "verify_code",
                                staticClass: "login-input",
                                staticStyle: { margin: "10px 0" },
                                attrs: {
                                  placeholder: "MFA Verification Code",
                                  oninput: "value=value.replace(/[^\\d]/g,'')",
                                },
                                model: {
                                  value: _vm.loginForm.verify_code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.loginForm, "verify_code", $$v)
                                  },
                                  expression: "loginForm.verify_code",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-form-item", [
                        _c(
                          "div",
                          {
                            staticClass: "forgot-password",
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("/forgotPassword")
                              },
                            },
                          },
                          [_vm._v("Forgot your password?")]
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "bg-color-main-linear-blue",
                          staticStyle: { width: "100%", "font-weight": "600" },
                          attrs: {
                            loading: _vm.loading,
                            type: "info",
                            size: "default",
                          },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.handleLogin($event)
                            },
                          },
                        },
                        [_vm._v("Login")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "mt-48",
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _c("img", {
                        staticClass: "login-bottom-logo",
                        attrs: {
                          src: _vm.$store.getters.isAruxpay
                            ? require("@/assets/logo/aruxpay_logo.png")
                            : require("@/assets/logo/ezpay_logo.svg"),
                        },
                      }),
                      _c("div", { staticClass: "text-all-right" }, [
                        _vm._v(
                          "©️ " +
                            _vm._s(new Date().getFullYear()) +
                            " " +
                            _vm._s(
                              _vm.$store.getters.isAruxpay ? "Aruxpay" : "Ezpay"
                            ) +
                            " Information Solutions Corp, All Rights Reserved"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _c("binding-mfa-modal", {
        ref: "bindingMFAModal",
        attrs: {
          "is-binding-mfa": _vm.is_binding_mfa,
          qr_code_base64: _vm.qr_code_base64,
          secret_key: _vm.secret_key,
        },
        on: { "verify-code-login": _vm.verifyCodeLogin },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }